/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AmountUnit,
    AmountUnitFromJSON,
    AmountUnitFromJSONTyped,
    AmountUnitToJSON,
    DurationUnit,
    DurationUnitFromJSON,
    DurationUnitFromJSONTyped,
    DurationUnitToJSON,
    EmailTemplate,
    EmailTemplateFromJSON,
    EmailTemplateFromJSONTyped,
    EmailTemplateToJSON,
    RewardType,
    RewardTypeFromJSON,
    RewardTypeFromJSONTyped,
    RewardTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface UpdateRewardConfigRequestBody
 */
export interface UpdateRewardConfigRequestBody {
    /**
     * 
     * @type {RewardType}
     * @memberof UpdateRewardConfigRequestBody
     */
    type?: RewardType;
    /**
     * 
     * @type {string}
     * @memberof UpdateRewardConfigRequestBody
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateRewardConfigRequestBody
     */
    description?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateRewardConfigRequestBody
     */
    shouldEmailUser?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateRewardConfigRequestBody
     */
    shouldEmailAdmin?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateRewardConfigRequestBody
     */
    shouldSendNotificationWeb?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateRewardConfigRequestBody
     */
    shouldSendNotificationDevourPlay?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpdateRewardConfigRequestBody
     */
    amount?: number;
    /**
     * 
     * @type {AmountUnit}
     * @memberof UpdateRewardConfigRequestBody
     */
    amountUnit?: AmountUnit;
    /**
     * 
     * @type {number}
     * @memberof UpdateRewardConfigRequestBody
     */
    durationAmount?: number;
    /**
     * 
     * @type {DurationUnit}
     * @memberof UpdateRewardConfigRequestBody
     */
    durationUnit?: DurationUnit;
    /**
     * 
     * @type {string}
     * @memberof UpdateRewardConfigRequestBody
     */
    assetId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateRewardConfigRequestBody
     */
    nftTrackerId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateRewardConfigRequestBody
     */
    orderDiscountId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateRewardConfigRequestBody
     */
    promoTokenId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateRewardConfigRequestBody
     */
    questConfigId?: string;
    /**
     * 
     * @type {EmailTemplate}
     * @memberof UpdateRewardConfigRequestBody
     */
    emailTemplate?: EmailTemplate;
    /**
     * 
     * @type {string}
     * @memberof UpdateRewardConfigRequestBody
     */
    claimFormUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateRewardConfigRequestBody
     */
    maxClaimCount?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateRewardConfigRequestBody
     */
    disclaimer?: string;
}

export function UpdateRewardConfigRequestBodyFromJSON(json: any): UpdateRewardConfigRequestBody {
    return UpdateRewardConfigRequestBodyFromJSONTyped(json, false);
}

export function UpdateRewardConfigRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateRewardConfigRequestBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': !exists(json, 'type') ? undefined : RewardTypeFromJSON(json['type']),
        'name': !exists(json, 'name') ? undefined : json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'shouldEmailUser': !exists(json, 'shouldEmailUser') ? undefined : json['shouldEmailUser'],
        'shouldEmailAdmin': !exists(json, 'shouldEmailAdmin') ? undefined : json['shouldEmailAdmin'],
        'shouldSendNotificationWeb': !exists(json, 'shouldSendNotificationWeb') ? undefined : json['shouldSendNotificationWeb'],
        'shouldSendNotificationDevourPlay': !exists(json, 'shouldSendNotificationDevourPlay') ? undefined : json['shouldSendNotificationDevourPlay'],
        'amount': !exists(json, 'amount') ? undefined : json['amount'],
        'amountUnit': !exists(json, 'amountUnit') ? undefined : AmountUnitFromJSON(json['amountUnit']),
        'durationAmount': !exists(json, 'durationAmount') ? undefined : json['durationAmount'],
        'durationUnit': !exists(json, 'durationUnit') ? undefined : DurationUnitFromJSON(json['durationUnit']),
        'assetId': !exists(json, 'assetId') ? undefined : json['assetId'],
        'nftTrackerId': !exists(json, 'nftTrackerId') ? undefined : json['nftTrackerId'],
        'orderDiscountId': !exists(json, 'orderDiscountId') ? undefined : json['orderDiscountId'],
        'promoTokenId': !exists(json, 'promoTokenId') ? undefined : json['promoTokenId'],
        'questConfigId': !exists(json, 'questConfigId') ? undefined : json['questConfigId'],
        'emailTemplate': !exists(json, 'emailTemplate') ? undefined : EmailTemplateFromJSON(json['emailTemplate']),
        'claimFormUrl': !exists(json, 'claimFormUrl') ? undefined : json['claimFormUrl'],
        'maxClaimCount': !exists(json, 'maxClaimCount') ? undefined : json['maxClaimCount'],
        'disclaimer': !exists(json, 'disclaimer') ? undefined : json['disclaimer'],
    };
}

export function UpdateRewardConfigRequestBodyToJSON(value?: UpdateRewardConfigRequestBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': RewardTypeToJSON(value.type),
        'name': value.name,
        'description': value.description,
        'shouldEmailUser': value.shouldEmailUser,
        'shouldEmailAdmin': value.shouldEmailAdmin,
        'shouldSendNotificationWeb': value.shouldSendNotificationWeb,
        'shouldSendNotificationDevourPlay': value.shouldSendNotificationDevourPlay,
        'amount': value.amount,
        'amountUnit': AmountUnitToJSON(value.amountUnit),
        'durationAmount': value.durationAmount,
        'durationUnit': DurationUnitToJSON(value.durationUnit),
        'assetId': value.assetId,
        'nftTrackerId': value.nftTrackerId,
        'orderDiscountId': value.orderDiscountId,
        'promoTokenId': value.promoTokenId,
        'questConfigId': value.questConfigId,
        'emailTemplate': EmailTemplateToJSON(value.emailTemplate),
        'claimFormUrl': value.claimFormUrl,
        'maxClaimCount': value.maxClaimCount,
        'disclaimer': value.disclaimer,
    };
}


